import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { MedIconTriangleLeftComponent } from "./med-icon-triangle-left.component";

@NgModule({
  declarations: [
    MedIconTriangleLeftComponent,
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    MedIconTriangleLeftComponent,
  ],
})
export class MedIconTriangleLeftModule { }
